.dialogContent {
	width: 100%;
	max-width: 720px;
	color: #333333;
	font-family: "Inter", sans-serif;
	display: flex;
	flex-direction: column;
}

/* Main Content Area */
.content {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 10px;
}

.headerContent {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 5px;
	margin-bottom: 12px;
}

.contentContainer {
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	gap: 14px;
	margin-top: 14px;
}

/* Step Section */
.stepsContainer {
	display: grid;
	grid-template-columns: 1fr max-content;
	align-items: center;
	border-radius: 14px;
	padding: 24px;
	background-color: #fdfbff;
	width: 100%;
}

.actionRow {
	display: contents;
}

.textColumn {
	display: flex;
	flex-direction: column;
	padding-right: 24px;
}

.buttonColumn {
	display: flex;
}

.actionButton {
	width: 100%;
	justify-content: center;
}

.dividerContainer {
	grid-column: 1 / -1;
	display: flex;
	align-items: center;
	text-align: center;
	margin: 24px 0;
}

.dividerLine {
	flex-grow: 1;
	border: 0.44px solid #e2e2ef;
}

.dividerText {
	margin: 0 16px;
	font-family: "Inter", sans-serif;
	font-weight: 400;
	font-style: normal;
	font-size: 14px;
	line-height: 160%;
	letter-spacing: 0px;
	color: #5b6473;
}

/* Info Section */
.infoRow {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 12px;
	padding: 6px 18px;
	border-radius: 12px;
	background: #fcfcfc;
}

/* Copy Link Section */
.expandableContainer {
	margin-top: 18px;
	display: flex;
	flex-direction: column;
	width: 100%;
}

.expandableHeader {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.copySection {
	display: flex;
	flex-direction: column;
	margin-top: 7px;
	gap: 7px;
}

.inputWrapper {
	width: 100%;
	height: 42px;
	border-radius: 10px;
	border: 1px solid #e5e7eb;
	padding: 0px 12px;
	background: #ffffff;
	display: flex;
	align-items: center;

	font-family: "Inter", sans-serif;
	font-weight: 400;
	font-style: normal;
	font-size: 12px;
	line-height: 16px;
	letter-spacing: 0px;
	color: #6a7282;
}

.linkRow {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 12px;
}

.copyButton {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	background-color: transparent;
	color: #4c4451;
	border: 1px solid #e5e7eb;
	border-radius: 10px;
	height: 42px;
	padding: 0 16px;
	min-width: 91px;
	text-transform: none;
	flex-shrink: 0;
}
a.supportLink {
	margin-top: 24px;

	font-family: "Inter", sans-serif;
	font-weight: 400;
	font-style: normal;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0;
	text-align: center;
	color: #16758a;
	text-decoration: underline;
	text-decoration-style: solid;
	text-decoration-skip-ink: auto;
}
